import { COMPANY } from "@/data/company";
import { useSeo } from "@/lib/useSeo";

function Section({ title, children }) {
  return (
    <div className="mb-8">
      <h2 className="font-heading text-xl font-bold text-ink mb-2">{title}</h2>
      <div className="text-ink/70 leading-relaxed space-y-2 text-sm">{children}</div>
    </div>
  );
}

export function MentionsLegales() {
  useSeo("Mentions légales", "Mentions légales du site SMT Provence.");
  return (
    <div className="pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-black text-ink mb-8">Mentions légales</h1>
        <Section title="Éditeur du site">
          <p><strong>{COMPANY.name}</strong> — {COMPANY.tagline}</p>
          <p>Forme juridique : SARL au capital de 1 000 €</p>
          <p>Siège social : {COMPANY.address}</p>
          <p>SIRET : {COMPANY.siret} — TVA intracommunautaire : {COMPANY.tva} — Code APE : {COMPANY.ape}</p>
          <p>Représentant légal : {COMPANY.dirigeant}</p>
          <p>Téléphone : {COMPANY.phone} — Email : {COMPANY.email}</p>
        </Section>
        <Section title="Directeur de la publication">
          <p>{COMPANY.dirigeant}, en qualité de dirigeant de {COMPANY.name}.</p>
        </Section>
        <Section title="Hébergement">
          <p>Le site est hébergé sur une infrastructure cloud sécurisée. Pour toute question relative à l'hébergement, contactez l'éditeur du site.</p>
        </Section>
        <Section title="Propriété intellectuelle">
          <p>L'ensemble des contenus (textes, images, logos, éléments graphiques) présents sur ce site est la propriété de {COMPANY.name}, sauf mention contraire, et est protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.</p>
        </Section>
        <Section title="Responsabilité">
          <p>{COMPANY.name} s'efforce d'assurer l'exactitude des informations diffusées sur ce site mais ne saurait être tenue responsable des erreurs, omissions ou d'une éventuelle indisponibilité du service.</p>
        </Section>
        <Section title="Conception & réalisation">
          <p>Site et application réalisés par <a href="https://besson-solutions.fr" target="_blank" rel="noopener noreferrer" className="text-primary underline">Besson-solutions.fr</a>.</p>
        </Section>
      </div>
    </div>
  );
}

export function Confidentialite() {
  useSeo("Politique de confidentialité", "Politique de confidentialité et gestion des données personnelles de SMT Provence.");
  return (
    <div className="pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-black text-ink mb-8">Politique de confidentialité</h1>
        <Section title="Collecte des données">
          <p>Les données personnelles collectées via nos formulaires (nom, téléphone, email, message) sont destinées uniquement à traiter votre demande de contact ou de devis. Aucune donnée n'est vendue à des tiers.</p>
        </Section>
        <Section title="Finalité du traitement">
          <p>Vos données sont utilisées pour : vous recontacter, établir un devis, assurer le suivi commercial de votre demande et améliorer nos services.</p>
        </Section>
        <Section title="Durée de conservation">
          <p>Les données sont conservées le temps nécessaire au traitement de votre demande, puis archivées conformément aux obligations légales, avant suppression.</p>
        </Section>
        <Section title="Vos droits (RGPD)">
          <p>Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'opposition, de limitation et de suppression de vos données. Pour exercer ces droits, contactez-nous à {COMPANY.email}.</p>
        </Section>
        <Section title="Cookies">
          <p>Ce site utilise des mesures d'audience anonymes afin d'améliorer votre navigation. Aucun cookie publicitaire tiers n'est déposé sans votre consentement.</p>
        </Section>
        <Section title="Contact">
          <p>Pour toute question relative à vos données : {COMPANY.email} — {COMPANY.phone}.</p>
        </Section>
      </div>
    </div>
  );
}
